import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface DeleteModuleVersionRequest {
  version_id: number;
  module_id?: number;
}

export function deleteModuleVersion(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'DeleteModuleVersion',
    description: 'Deletes a module version',
    execute: (data: DeleteModuleVersionRequest): Observable<any> => {
      if (!data.version_id) {
        return of({ success: false, error: 'Missing required field: version_id' });
      }
      return componentDataSourceService.http.delete<any>(
        `${environment.apiUrl}/events/modules/versions/${data.version_id}`
      ).pipe(
        tap(() => {
          dataSharingService.setData('modules_updated', {
            timestamp: Date.now(),
            ...(data.module_id && { module_id: data.module_id })
          });
        }),
        catchError(err => {
          console.error('[DeleteModuleVersion] Error:', err);
          throw err;
        })
      );
    }
  };
}
